module.exports = __webpack_public_path__ + "img/box9-15.43cf2110.png";